import api from "./api";

export const getCompanyStats = async () => {
  try {
    const response = await api.get("/statistiques/company");
    return response.data;
  } catch (error) {
    console.error("Erreur stats:", error);
    throw error;
  }
};